module.exports = window["MaterialUI"];